<template lang="html">
  <div>
    <div class="login__atmosphere">
      <img :src="require('img/login/loginUser.png')" />
    </div>
    <h2 class="login-form__title">{{ $t('login.mfaTitle') }}</h2>
    <p class="login-form__text">
     {{ $t('login.mfaDescription') }}
    </p>
    <div v-on:keyup.enter="send">
      <p4a-input class="login-input"
                :type="'text'"
                :size="'large'"
                :warning="{visible: MfaValidated, showIcon: true, message: ''}"
                :valid="false"
                :placeholder="$t('login.mfaPlaceholder')"
                :fullWidth="true"
                :autofocus="true"
                v-model="MfaInput" />
      <p4a-button class="login-button"
                  :showIcon="false"
                  :onlyIconVisible="false"
                  :product="'ds'"
                  :size="'large'"
                  :disable="false"
                  :fullWidth="true"
                  :text="$t('login.mfaButton')"
                  @click="send">
      </p4a-button>
    </div>
    <div class="login-form__link">
      <router-link to="/login" class="login-form__link--section">{{ $t('login.back') }}</router-link>
    </div>

  </div>
</template>

<script>
import * as usersAndGroupsApi from 'api/usersAndGroupsApi'
import { getPostAuthRoute } from 'router'

export default {
  name: 'loginMfa',
  data () {
    let self = this
    return {
      MfaId: self.$route.params.mfaId,
      MfaValidated: false,
      MfaInput: null
    }
  },
  methods: {
    send () {
      let self = this
      if (self.MfaInput === null) {
        self.MfaValidated = true
      } else {
        usersAndGroupsApi.verifyMfa({ Code: self.MfaInput, MfaId: self.MfaId }).then(success => {
          if (success) {
            let route = getPostAuthRoute()
            if (route && route.query && route.query.ReturnUrl && route.query.ReturnUrl !== '/') {
              window.location = route.query.ReturnUrl
            } else {
              window.location = '/index.aspx'
            }
          } else {
            self.MfaValidated = true
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/inputs/loginMfa.vue